export default "__VITE_ASSET__LhDxxEWV__"